import { FileSearch, ArrowRight, Lock } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";
import { TRUST_URL } from "../lib/constants";

export const HaveTrust = () => (
  <section className="bg-parchment py-24 sm:py-36" data-testid="have-trust-section">
    <div className="max-w-5xl mx-auto px-5 sm:px-8">
      <Reveal>
        <div className="bg-white border border-ink/10 rounded-3xl p-8 sm:p-16 shadow-xl relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-goldeep/8 blur-3xl rounded-full" aria-hidden="true" />
          <div className="flex items-start gap-6 flex-col sm:flex-row">
            <div className="w-16 h-16 rounded-full bg-goldeep/10 border border-goldeep/30 flex items-center justify-center text-goldeep shrink-0">
              <FileSearch size={26} strokeWidth={1.8} />
            </div>
            <div>
              <Eyebrow>Free Review</Eyebrow>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-ink tracking-tight leading-[1.08] mt-5">
                Already Have a Trust. <em className="text-goldeep italic">Let Me See It.</em>
              </h2>
              <p className="text-ink/70 text-base sm:text-lg leading-relaxed mt-6">
                Good. Most people do not. But here is what I have learned. Most trusts are either sitting
                empty, missing key protections, or were written under laws that have since changed.
              </p>
              <p className="text-ink/70 text-base sm:text-lg leading-relaxed mt-4">
                Bring it to me. I will review it at no cost and tell you exactly where you stand. If it is
                solid I will tell you. If there is a gap I will show you and I will show you what it takes to
                close it.
              </p>
              <a
                href={TRUST_URL}
                data-testid="upload-trust-btn"
                className="group inline-flex items-center gap-3 bg-ink text-cream font-bold text-sm tracking-[0.1em] uppercase px-8 py-4 rounded-full mt-9 hover:bg-goldeep transition-colors duration-300"
              >
                Upload Your Trust for Free Review
                <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1.5" />
              </a>
              <p className="text-ink/50 text-sm mt-5 tracking-wide">No cost. No commitment. Just answers.</p>
              <p className="flex items-start gap-2 text-ink/55 text-xs sm:text-sm leading-relaxed mt-4" data-testid="upload-security-statement">
                <Lock size={14} className="text-goldeep shrink-0 mt-0.5" />
                All personal information you provide, including Social Security Numbers, is protected with
                military grade AES 256 GCM encryption.
              </p>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
